var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 13.55C13.1363 13.8895 13.75 14.3355 13.75 14.824C13.75 15.8877 10.8399 16.75 7.25 16.75C3.66015 16.75 0.75 15.8877 0.75 14.824C0.75 14.3355 1.36366 13.8895 2.375 13.55M9.6875 6.75C9.6875 8.07548 8.59619 9.15 7.25 9.15C5.90381 9.15 4.8125 8.07548 4.8125 6.75C4.8125 5.42452 5.90381 4.35 7.25 4.35C8.59619 4.35 9.6875 5.42452 9.6875 6.75ZM7.25 0.75C3.95223 0.75 1.15625 3.49242 1.15625 6.81952C1.15625 10.2113 4.00264 12.5559 6.62234 14.1845C6.81362 14.293 7.02992 14.35 7.25 14.35C7.47008 14.35 7.68638 14.293 7.87766 14.1845C10.5022 12.5716 13.3438 10.1996 13.3438 6.81952C13.3437 3.49242 10.5478 0.75 7.25 0.75Z",
    stroke: "#9810FA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorAddress);
export default __webpack_public_path__ + "static/media/distributorAddress.540fa6d85a7aafe87b2c9d1818864b8e.svg";
export { ForwardRef as ReactComponent };